import * as React from "react";
import { FieldValueLocaleText, Language, Map } from "typings/index";
import { BaseFieldEditor } from "./helper";
import KeyValueList from "../../translations/KeyValueList";
import { DefaultButton, Dialog, DialogFooter, PrimaryButton, CommandBar, ICommandBarItemProps } from "office-ui-fabric-react";
import styled from "styled-components";
import { GetLanguageMenu } from "./localeTextareaEditor/languageHelper";
export interface Props extends BaseFieldEditor
{
    value: FieldValueLocaleText;
    languages: Language[];
    placeholder?: string;
}

const Editor = styled.div`
    min-width: 220px;

    span{
        cursor: pointer;
        width: 94%;
        height: 100%;
        display: block;
        background: white;
        padding: 3%;
        white-space: pre-wrap;
        min-height: 18px;
   }
`;

function LocaleTextEditor(props: Props)
{
    const [language, setLanguage] = React.useState<Language>(props.languages[0]);
    const [edit, setEdit] = React.useState<boolean>(false);

    const [value, setValue] = React.useState<Map<string> | undefined>(props.value ? props.value.value : undefined);
    React.useEffect(() =>
    {
        setValue(props.value ? props.value.value : undefined);
    }, [props.value]);
    const toggleEditMode = () => setEdit(!edit);

    const onSave = () =>
    {
        const fieldValue: FieldValueLocaleText = {...props.value, value };
        props.onValueChange(fieldValue);
        toggleEditMode();
    };
   
    const onValueChange = (language: string, newValue: string) =>
    {
        const temp= {...value};
        temp[language] = newValue;
        setValue(temp);
    };
    const commandBarOptions: ICommandBarItemProps[] = GetLanguageMenu(props.languages, setLanguage, language);
    const keyValuePair: Map<string> = {};
    props.languages.forEach(lang => keyValuePair[lang.name] = value && (lang.name in value) ? value[lang.name] : "");
    return (
        <Editor key={props.field.name}>
            <CommandBar
            style={{background: "transparent"}}
            items={commandBarOptions}
            farItems={[{name:"Edit", key:"edit", onClick: toggleEditMode}]}
            />
            <span onClick={toggleEditMode}>
                {value && language ? value[language.name] : undefined}
            </span>
            <Dialog hidden={!edit} onDismiss={toggleEditMode} minWidth={550}>
                <KeyValueList 
                    keyTitle={"language"}
                    valueTitle={props.field.label._DEFAULT}
                    list={keyValuePair}
                    onChange={onValueChange}
                />
                    <DialogFooter>
                    <PrimaryButton onClick={onSave} text="Save" />
                    <DefaultButton onClick={toggleEditMode} text="Cancel" />
                </DialogFooter>
            </Dialog>
        </Editor>
    );
}

export default LocaleTextEditor;


// WEBPACK FOOTER //
// ./src/components/product/FieldEditor/LocaleTextEditor.tsx